import { makeModuleStateSelector } from "@client/content/selectors";
import {
  type SettingsPropsParametricSelector,
  TargetSelector,
  getColorSelector,
  makeBorderStyleSelector
} from "@client/selectors";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import type { KnowledgeBase } from "./types";

export const localStateSelector = makeModuleStateSelector<KnowledgeBase.State>(defaultState, previewState);

export const makeStyleSelector = (): SettingsPropsParametricSelector => {
  const backgroundColorSelector = getColorSelector(TargetSelector.Entity, "backgroundColor", "item");

  const borderStyleSelector = makeBorderStyleSelector(TargetSelector.Entity, "item");

  return createSelector(
    [backgroundColorSelector, borderStyleSelector],
    (backgroundColor, borderStyle): React.CSSProperties => ({
      ...borderStyle,
      backgroundColor
    })
  );
};
